export interface Crime {
  /** crime arrested for */
  offenseCategory: string
  /** formatted day of week arrest made */
  dow: string
  /** formatted hour of day arrest made */
  hr: string
  /** number of arrests made in time period */
  count: number
}

/**
 * **Crime counts in Orlando, FL summarized by offense and time of day between 2009 and 2015**. Data originally collected from [City of Orlando Open Data](https://data.cityoforlando.net/).
 */
export const crimes: Crime[] = [
  {
    offenseCategory: 'Theft',
    dow: 'Monday',
    hr: '6 am',
    count: 197,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Monday',
    hr: '7 am',
    count: 524,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Monday',
    hr: '8 am',
    count: 836,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Monday',
    hr: '9 am',
    count: 950,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Monday',
    hr: '10 am',
    count: 1072,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Monday',
    hr: '11 am',
    count: 1058,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Monday',
    hr: '12 pm',
    count: 934,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Monday',
    hr: '1 pm',
    count: 1054,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Monday',
    hr: '2 pm',
    count: 958,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Monday',
    hr: '3 pm',
    count: 909,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Monday',
    hr: '4 pm',
    count: 848,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Monday',
    hr: '5 pm',
    count: 751,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Monday',
    hr: '6 pm',
    count: 697,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Monday',
    hr: '7 pm',
    count: 524,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Monday',
    hr: '8 pm',
    count: 447,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Monday',
    hr: '9 pm',
    count: 412,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Monday',
    hr: '10 pm',
    count: 281,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Monday',
    hr: '11 pm',
    count: 217,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Monday',
    hr: '12 am',
    count: 174,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Monday',
    hr: '1 am',
    count: 146,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Monday',
    hr: '2 am',
    count: 138,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Monday',
    hr: '3 am',
    count: 92,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Monday',
    hr: '4 am',
    count: 62,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Monday',
    hr: '5 am',
    count: 93,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Tuesday',
    hr: '6 am',
    count: 167,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Tuesday',
    hr: '7 am',
    count: 444,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Tuesday',
    hr: '8 am',
    count: 703,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Tuesday',
    hr: '9 am',
    count: 810,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Tuesday',
    hr: '10 am',
    count: 857,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Tuesday',
    hr: '11 am',
    count: 908,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Tuesday',
    hr: '12 pm',
    count: 878,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Tuesday',
    hr: '1 pm',
    count: 912,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Tuesday',
    hr: '2 pm',
    count: 868,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Tuesday',
    hr: '3 pm',
    count: 869,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Tuesday',
    hr: '4 pm',
    count: 808,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Tuesday',
    hr: '5 pm',
    count: 696,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Tuesday',
    hr: '6 pm',
    count: 583,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Tuesday',
    hr: '7 pm',
    count: 570,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Tuesday',
    hr: '8 pm',
    count: 468,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Tuesday',
    hr: '9 pm',
    count: 366,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Tuesday',
    hr: '10 pm',
    count: 299,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Tuesday',
    hr: '11 pm',
    count: 221,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Tuesday',
    hr: '12 am',
    count: 168,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Tuesday',
    hr: '1 am',
    count: 118,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Tuesday',
    hr: '2 am',
    count: 113,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Tuesday',
    hr: '3 am',
    count: 83,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Tuesday',
    hr: '4 am',
    count: 70,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Tuesday',
    hr: '5 am',
    count: 94,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Wednesday',
    hr: '6 am',
    count: 185,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Wednesday',
    hr: '7 am',
    count: 442,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Wednesday',
    hr: '8 am',
    count: 684,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Wednesday',
    hr: '9 am',
    count: 742,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Wednesday',
    hr: '10 am',
    count: 775,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Wednesday',
    hr: '11 am',
    count: 863,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Wednesday',
    hr: '12 pm',
    count: 890,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Wednesday',
    hr: '1 pm',
    count: 859,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Wednesday',
    hr: '2 pm',
    count: 865,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Wednesday',
    hr: '3 pm',
    count: 877,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Wednesday',
    hr: '4 pm',
    count: 813,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Wednesday',
    hr: '5 pm',
    count: 653,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Wednesday',
    hr: '6 pm',
    count: 601,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Wednesday',
    hr: '7 pm',
    count: 503,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Wednesday',
    hr: '8 pm',
    count: 430,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Wednesday',
    hr: '9 pm',
    count: 364,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Wednesday',
    hr: '10 pm',
    count: 261,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Wednesday',
    hr: '11 pm',
    count: 188,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Wednesday',
    hr: '12 am',
    count: 157,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Wednesday',
    hr: '1 am',
    count: 123,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Wednesday',
    hr: '2 am',
    count: 130,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Wednesday',
    hr: '3 am',
    count: 80,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Wednesday',
    hr: '4 am',
    count: 77,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Wednesday',
    hr: '5 am',
    count: 94,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Thursday',
    hr: '6 am',
    count: 178,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Thursday',
    hr: '7 am',
    count: 396,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Thursday',
    hr: '8 am',
    count: 652,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Thursday',
    hr: '9 am',
    count: 804,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Thursday',
    hr: '10 am',
    count: 765,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Thursday',
    hr: '11 am',
    count: 860,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Thursday',
    hr: '12 pm',
    count: 811,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Thursday',
    hr: '1 pm',
    count: 908,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Thursday',
    hr: '2 pm',
    count: 837,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Thursday',
    hr: '3 pm',
    count: 863,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Thursday',
    hr: '4 pm',
    count: 777,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Thursday',
    hr: '5 pm',
    count: 692,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Thursday',
    hr: '6 pm',
    count: 566,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Thursday',
    hr: '7 pm',
    count: 523,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Thursday',
    hr: '8 pm',
    count: 435,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Thursday',
    hr: '9 pm',
    count: 358,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Thursday',
    hr: '10 pm',
    count: 246,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Thursday',
    hr: '11 pm',
    count: 195,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Thursday',
    hr: '12 am',
    count: 178,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Thursday',
    hr: '1 am',
    count: 152,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Thursday',
    hr: '2 am',
    count: 136,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Thursday',
    hr: '3 am',
    count: 89,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Thursday',
    hr: '4 am',
    count: 82,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Thursday',
    hr: '5 am',
    count: 97,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Friday',
    hr: '6 am',
    count: 179,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Friday',
    hr: '7 am',
    count: 390,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Friday',
    hr: '8 am',
    count: 617,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Friday',
    hr: '9 am',
    count: 744,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Friday',
    hr: '10 am',
    count: 723,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Friday',
    hr: '11 am',
    count: 815,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Friday',
    hr: '12 pm',
    count: 803,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Friday',
    hr: '1 pm',
    count: 844,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Friday',
    hr: '2 pm',
    count: 834,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Friday',
    hr: '3 pm',
    count: 863,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Friday',
    hr: '4 pm',
    count: 766,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Friday',
    hr: '5 pm',
    count: 725,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Friday',
    hr: '6 pm',
    count: 584,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Friday',
    hr: '7 pm',
    count: 479,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Friday',
    hr: '8 pm',
    count: 486,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Friday',
    hr: '9 pm',
    count: 372,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Friday',
    hr: '10 pm',
    count: 318,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Friday',
    hr: '11 pm',
    count: 253,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Friday',
    hr: '12 am',
    count: 166,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Friday',
    hr: '1 am',
    count: 162,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Friday',
    hr: '2 am',
    count: 134,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Friday',
    hr: '3 am',
    count: 130,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Friday',
    hr: '4 am',
    count: 78,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Friday',
    hr: '5 am',
    count: 82,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Saturday',
    hr: '6 am',
    count: 114,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Saturday',
    hr: '7 am',
    count: 206,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Saturday',
    hr: '8 am',
    count: 319,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Saturday',
    hr: '9 am',
    count: 397,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Saturday',
    hr: '10 am',
    count: 511,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Saturday',
    hr: '11 am',
    count: 584,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Saturday',
    hr: '12 pm',
    count: 579,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Saturday',
    hr: '1 pm',
    count: 622,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Saturday',
    hr: '2 pm',
    count: 632,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Saturday',
    hr: '3 pm',
    count: 613,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Saturday',
    hr: '4 pm',
    count: 663,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Saturday',
    hr: '5 pm',
    count: 622,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Saturday',
    hr: '6 pm',
    count: 603,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Saturday',
    hr: '7 pm',
    count: 521,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Saturday',
    hr: '8 pm',
    count: 462,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Saturday',
    hr: '9 pm',
    count: 407,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Saturday',
    hr: '10 pm',
    count: 302,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Saturday',
    hr: '11 pm',
    count: 242,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Saturday',
    hr: '12 am',
    count: 169,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Saturday',
    hr: '1 am',
    count: 197,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Saturday',
    hr: '2 am',
    count: 197,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Saturday',
    hr: '3 am',
    count: 178,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Saturday',
    hr: '4 am',
    count: 110,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Saturday',
    hr: '5 am',
    count: 91,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Sunday',
    hr: '6 am',
    count: 98,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Sunday',
    hr: '7 am',
    count: 184,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Sunday',
    hr: '8 am',
    count: 278,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Sunday',
    hr: '9 am',
    count: 380,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Sunday',
    hr: '10 am',
    count: 474,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Sunday',
    hr: '11 am',
    count: 510,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Sunday',
    hr: '12 pm',
    count: 540,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Sunday',
    hr: '1 pm',
    count: 553,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Sunday',
    hr: '2 pm',
    count: 567,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Sunday',
    hr: '3 pm',
    count: 566,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Sunday',
    hr: '4 pm',
    count: 586,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Sunday',
    hr: '5 pm',
    count: 567,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Sunday',
    hr: '6 pm',
    count: 525,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Sunday',
    hr: '7 pm',
    count: 516,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Sunday',
    hr: '8 pm',
    count: 383,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Sunday',
    hr: '9 pm',
    count: 338,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Sunday',
    hr: '10 pm',
    count: 301,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Sunday',
    hr: '11 pm',
    count: 190,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Sunday',
    hr: '12 am',
    count: 209,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Sunday',
    hr: '1 am',
    count: 196,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Sunday',
    hr: '2 am',
    count: 214,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Sunday',
    hr: '3 am',
    count: 179,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Sunday',
    hr: '4 am',
    count: 101,
  },
  {
    offenseCategory: 'Theft',
    dow: 'Sunday',
    hr: '5 am',
    count: 99,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Monday',
    hr: '6 am',
    count: 98,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Monday',
    hr: '7 am',
    count: 212,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Monday',
    hr: '8 am',
    count: 273,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Monday',
    hr: '9 am',
    count: 275,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Monday',
    hr: '10 am',
    count: 272,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Monday',
    hr: '11 am',
    count: 270,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Monday',
    hr: '12 pm',
    count: 307,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Monday',
    hr: '1 pm',
    count: 243,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Monday',
    hr: '2 pm',
    count: 245,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Monday',
    hr: '3 pm',
    count: 262,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Monday',
    hr: '4 pm',
    count: 256,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Monday',
    hr: '5 pm',
    count: 256,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Monday',
    hr: '6 pm',
    count: 259,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Monday',
    hr: '7 pm',
    count: 182,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Monday',
    hr: '8 pm',
    count: 151,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Monday',
    hr: '9 pm',
    count: 130,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Monday',
    hr: '10 pm',
    count: 140,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Monday',
    hr: '11 pm',
    count: 109,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Monday',
    hr: '12 am',
    count: 87,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Monday',
    hr: '1 am',
    count: 62,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Monday',
    hr: '2 am',
    count: 57,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Monday',
    hr: '3 am',
    count: 52,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Monday',
    hr: '4 am',
    count: 52,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Monday',
    hr: '5 am',
    count: 42,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Tuesday',
    hr: '6 am',
    count: 77,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Tuesday',
    hr: '7 am',
    count: 122,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Tuesday',
    hr: '8 am',
    count: 155,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Tuesday',
    hr: '9 am',
    count: 185,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Tuesday',
    hr: '10 am',
    count: 233,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Tuesday',
    hr: '11 am',
    count: 222,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Tuesday',
    hr: '12 pm',
    count: 244,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Tuesday',
    hr: '1 pm',
    count: 234,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Tuesday',
    hr: '2 pm',
    count: 248,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Tuesday',
    hr: '3 pm',
    count: 284,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Tuesday',
    hr: '4 pm',
    count: 249,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Tuesday',
    hr: '5 pm',
    count: 254,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Tuesday',
    hr: '6 pm',
    count: 244,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Tuesday',
    hr: '7 pm',
    count: 190,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Tuesday',
    hr: '8 pm',
    count: 160,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Tuesday',
    hr: '9 pm',
    count: 157,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Tuesday',
    hr: '10 pm',
    count: 145,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Tuesday',
    hr: '11 pm',
    count: 109,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Tuesday',
    hr: '12 am',
    count: 68,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Tuesday',
    hr: '1 am',
    count: 59,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Tuesday',
    hr: '2 am',
    count: 59,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Tuesday',
    hr: '3 am',
    count: 47,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Tuesday',
    hr: '4 am',
    count: 46,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Tuesday',
    hr: '5 am',
    count: 53,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Wednesday',
    hr: '6 am',
    count: 53,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Wednesday',
    hr: '7 am',
    count: 127,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Wednesday',
    hr: '8 am',
    count: 197,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Wednesday',
    hr: '9 am',
    count: 197,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Wednesday',
    hr: '10 am',
    count: 236,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Wednesday',
    hr: '11 am',
    count: 222,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Wednesday',
    hr: '12 pm',
    count: 213,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Wednesday',
    hr: '1 pm',
    count: 272,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Wednesday',
    hr: '2 pm',
    count: 243,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Wednesday',
    hr: '3 pm',
    count: 241,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Wednesday',
    hr: '4 pm',
    count: 223,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Wednesday',
    hr: '5 pm',
    count: 237,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Wednesday',
    hr: '6 pm',
    count: 202,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Wednesday',
    hr: '7 pm',
    count: 184,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Wednesday',
    hr: '8 pm',
    count: 147,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Wednesday',
    hr: '9 pm',
    count: 171,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Wednesday',
    hr: '10 pm',
    count: 142,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Wednesday',
    hr: '11 pm',
    count: 105,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Wednesday',
    hr: '12 am',
    count: 87,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Wednesday',
    hr: '1 am',
    count: 53,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Wednesday',
    hr: '2 am',
    count: 61,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Wednesday',
    hr: '3 am',
    count: 60,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Wednesday',
    hr: '4 am',
    count: 58,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Wednesday',
    hr: '5 am',
    count: 49,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Thursday',
    hr: '6 am',
    count: 56,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Thursday',
    hr: '7 am',
    count: 112,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Thursday',
    hr: '8 am',
    count: 166,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Thursday',
    hr: '9 am',
    count: 189,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Thursday',
    hr: '10 am',
    count: 221,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Thursday',
    hr: '11 am',
    count: 206,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Thursday',
    hr: '12 pm',
    count: 221,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Thursday',
    hr: '1 pm',
    count: 248,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Thursday',
    hr: '2 pm',
    count: 227,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Thursday',
    hr: '3 pm',
    count: 234,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Thursday',
    hr: '4 pm',
    count: 248,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Thursday',
    hr: '5 pm',
    count: 270,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Thursday',
    hr: '6 pm',
    count: 206,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Thursday',
    hr: '7 pm',
    count: 176,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Thursday',
    hr: '8 pm',
    count: 128,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Thursday',
    hr: '9 pm',
    count: 157,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Thursday',
    hr: '10 pm',
    count: 143,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Thursday',
    hr: '11 pm',
    count: 95,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Thursday',
    hr: '12 am',
    count: 76,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Thursday',
    hr: '1 am',
    count: 58,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Thursday',
    hr: '2 am',
    count: 68,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Thursday',
    hr: '3 am',
    count: 54,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Thursday',
    hr: '4 am',
    count: 59,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Thursday',
    hr: '5 am',
    count: 45,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Friday',
    hr: '6 am',
    count: 57,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Friday',
    hr: '7 am',
    count: 124,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Friday',
    hr: '8 am',
    count: 188,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Friday',
    hr: '9 am',
    count: 204,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Friday',
    hr: '10 am',
    count: 205,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Friday',
    hr: '11 am',
    count: 198,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Friday',
    hr: '12 pm',
    count: 215,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Friday',
    hr: '1 pm',
    count: 200,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Friday',
    hr: '2 pm',
    count: 237,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Friday',
    hr: '3 pm',
    count: 225,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Friday',
    hr: '4 pm',
    count: 211,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Friday',
    hr: '5 pm',
    count: 210,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Friday',
    hr: '6 pm',
    count: 203,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Friday',
    hr: '7 pm',
    count: 154,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Friday',
    hr: '8 pm',
    count: 149,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Friday',
    hr: '9 pm',
    count: 142,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Friday',
    hr: '10 pm',
    count: 146,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Friday',
    hr: '11 pm',
    count: 134,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Friday',
    hr: '12 am',
    count: 90,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Friday',
    hr: '1 am',
    count: 81,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Friday',
    hr: '2 am',
    count: 61,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Friday',
    hr: '3 am',
    count: 52,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Friday',
    hr: '4 am',
    count: 50,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Friday',
    hr: '5 am',
    count: 42,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Saturday',
    hr: '6 am',
    count: 43,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Saturday',
    hr: '7 am',
    count: 71,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Saturday',
    hr: '8 am',
    count: 117,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Saturday',
    hr: '9 am',
    count: 123,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Saturday',
    hr: '10 am',
    count: 142,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Saturday',
    hr: '11 am',
    count: 127,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Saturday',
    hr: '12 pm',
    count: 131,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Saturday',
    hr: '1 pm',
    count: 131,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Saturday',
    hr: '2 pm',
    count: 130,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Saturday',
    hr: '3 pm',
    count: 146,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Saturday',
    hr: '4 pm',
    count: 115,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Saturday',
    hr: '5 pm',
    count: 116,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Saturday',
    hr: '6 pm',
    count: 133,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Saturday',
    hr: '7 pm',
    count: 128,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Saturday',
    hr: '8 pm',
    count: 118,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Saturday',
    hr: '9 pm',
    count: 104,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Saturday',
    hr: '10 pm',
    count: 142,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Saturday',
    hr: '11 pm',
    count: 112,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Saturday',
    hr: '12 am',
    count: 107,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Saturday',
    hr: '1 am',
    count: 86,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Saturday',
    hr: '2 am',
    count: 92,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Saturday',
    hr: '3 am',
    count: 55,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Saturday',
    hr: '4 am',
    count: 57,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Saturday',
    hr: '5 am',
    count: 46,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Sunday',
    hr: '6 am',
    count: 41,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Sunday',
    hr: '7 am',
    count: 59,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Sunday',
    hr: '8 am',
    count: 92,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Sunday',
    hr: '9 am',
    count: 112,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Sunday',
    hr: '10 am',
    count: 130,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Sunday',
    hr: '11 am',
    count: 131,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Sunday',
    hr: '12 pm',
    count: 142,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Sunday',
    hr: '1 pm',
    count: 146,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Sunday',
    hr: '2 pm',
    count: 157,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Sunday',
    hr: '3 pm',
    count: 122,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Sunday',
    hr: '4 pm',
    count: 133,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Sunday',
    hr: '5 pm',
    count: 140,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Sunday',
    hr: '6 pm',
    count: 113,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Sunday',
    hr: '7 pm',
    count: 126,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Sunday',
    hr: '8 pm',
    count: 114,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Sunday',
    hr: '9 pm',
    count: 138,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Sunday',
    hr: '10 pm',
    count: 138,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Sunday',
    hr: '11 pm',
    count: 100,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Sunday',
    hr: '12 am',
    count: 101,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Sunday',
    hr: '1 am',
    count: 95,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Sunday',
    hr: '2 am',
    count: 63,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Sunday',
    hr: '3 am',
    count: 58,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Sunday',
    hr: '4 am',
    count: 43,
  },
  {
    offenseCategory: 'Burglary',
    dow: 'Sunday',
    hr: '5 am',
    count: 40,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Monday',
    hr: '6 am',
    count: 13,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Monday',
    hr: '7 am',
    count: 12,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Monday',
    hr: '8 am',
    count: 15,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Monday',
    hr: '9 am',
    count: 21,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Monday',
    hr: '10 am',
    count: 42,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Monday',
    hr: '11 am',
    count: 48,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Monday',
    hr: '12 pm',
    count: 70,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Monday',
    hr: '1 pm',
    count: 48,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Monday',
    hr: '2 pm',
    count: 72,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Monday',
    hr: '3 pm',
    count: 72,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Monday',
    hr: '4 pm',
    count: 70,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Monday',
    hr: '5 pm',
    count: 60,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Monday',
    hr: '6 pm',
    count: 100,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Monday',
    hr: '7 pm',
    count: 125,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Monday',
    hr: '8 pm',
    count: 117,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Monday',
    hr: '9 pm',
    count: 134,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Monday',
    hr: '10 pm',
    count: 128,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Monday',
    hr: '11 pm',
    count: 181,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Monday',
    hr: '12 am',
    count: 156,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Monday',
    hr: '1 am',
    count: 129,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Monday',
    hr: '2 am',
    count: 112,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Monday',
    hr: '3 am',
    count: 78,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Monday',
    hr: '4 am',
    count: 32,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Monday',
    hr: '5 am',
    count: 22,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Tuesday',
    hr: '6 am',
    count: 20,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Tuesday',
    hr: '7 am',
    count: 32,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Tuesday',
    hr: '8 am',
    count: 28,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Tuesday',
    hr: '9 am',
    count: 32,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Tuesday',
    hr: '10 am',
    count: 55,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Tuesday',
    hr: '11 am',
    count: 68,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Tuesday',
    hr: '12 pm',
    count: 70,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Tuesday',
    hr: '1 pm',
    count: 80,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Tuesday',
    hr: '2 pm',
    count: 143,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Tuesday',
    hr: '3 pm',
    count: 158,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Tuesday',
    hr: '4 pm',
    count: 204,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Tuesday',
    hr: '5 pm',
    count: 164,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Tuesday',
    hr: '6 pm',
    count: 209,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Tuesday',
    hr: '7 pm',
    count: 262,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Tuesday',
    hr: '8 pm',
    count: 237,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Tuesday',
    hr: '9 pm',
    count: 208,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Tuesday',
    hr: '10 pm',
    count: 235,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Tuesday',
    hr: '11 pm',
    count: 194,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Tuesday',
    hr: '12 am',
    count: 172,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Tuesday',
    hr: '1 am',
    count: 165,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Tuesday',
    hr: '2 am',
    count: 117,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Tuesday',
    hr: '3 am',
    count: 87,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Tuesday',
    hr: '4 am',
    count: 40,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Tuesday',
    hr: '5 am',
    count: 24,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Wednesday',
    hr: '6 am',
    count: 22,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Wednesday',
    hr: '7 am',
    count: 21,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Wednesday',
    hr: '8 am',
    count: 33,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Wednesday',
    hr: '9 am',
    count: 39,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Wednesday',
    hr: '10 am',
    count: 53,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Wednesday',
    hr: '11 am',
    count: 80,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Wednesday',
    hr: '12 pm',
    count: 124,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Wednesday',
    hr: '1 pm',
    count: 113,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Wednesday',
    hr: '2 pm',
    count: 154,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Wednesday',
    hr: '3 pm',
    count: 211,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Wednesday',
    hr: '4 pm',
    count: 192,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Wednesday',
    hr: '5 pm',
    count: 212,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Wednesday',
    hr: '6 pm',
    count: 279,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Wednesday',
    hr: '7 pm',
    count: 257,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Wednesday',
    hr: '8 pm',
    count: 274,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Wednesday',
    hr: '9 pm',
    count: 277,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Wednesday',
    hr: '10 pm',
    count: 250,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Wednesday',
    hr: '11 pm',
    count: 260,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Wednesday',
    hr: '12 am',
    count: 236,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Wednesday',
    hr: '1 am',
    count: 156,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Wednesday',
    hr: '2 am',
    count: 118,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Wednesday',
    hr: '3 am',
    count: 79,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Wednesday',
    hr: '4 am',
    count: 46,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Wednesday',
    hr: '5 am',
    count: 18,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Thursday',
    hr: '6 am',
    count: 22,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Thursday',
    hr: '7 am',
    count: 22,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Thursday',
    hr: '8 am',
    count: 24,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Thursday',
    hr: '9 am',
    count: 51,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Thursday',
    hr: '10 am',
    count: 65,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Thursday',
    hr: '11 am',
    count: 91,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Thursday',
    hr: '12 pm',
    count: 81,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Thursday',
    hr: '1 pm',
    count: 91,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Thursday',
    hr: '2 pm',
    count: 137,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Thursday',
    hr: '3 pm',
    count: 180,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Thursday',
    hr: '4 pm',
    count: 215,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Thursday',
    hr: '5 pm',
    count: 180,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Thursday',
    hr: '6 pm',
    count: 201,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Thursday',
    hr: '7 pm',
    count: 254,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Thursday',
    hr: '8 pm',
    count: 243,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Thursday',
    hr: '9 pm',
    count: 199,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Thursday',
    hr: '10 pm',
    count: 231,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Thursday',
    hr: '11 pm',
    count: 219,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Thursday',
    hr: '12 am',
    count: 225,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Thursday',
    hr: '1 am',
    count: 144,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Thursday',
    hr: '2 am',
    count: 142,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Thursday',
    hr: '3 am',
    count: 89,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Thursday',
    hr: '4 am',
    count: 40,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Thursday',
    hr: '5 am',
    count: 25,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Friday',
    hr: '6 am',
    count: 16,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Friday',
    hr: '7 am',
    count: 19,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Friday',
    hr: '8 am',
    count: 27,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Friday',
    hr: '9 am',
    count: 40,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Friday',
    hr: '10 am',
    count: 52,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Friday',
    hr: '11 am',
    count: 56,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Friday',
    hr: '12 pm',
    count: 73,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Friday',
    hr: '1 pm',
    count: 92,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Friday',
    hr: '2 pm',
    count: 131,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Friday',
    hr: '3 pm',
    count: 133,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Friday',
    hr: '4 pm',
    count: 124,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Friday',
    hr: '5 pm',
    count: 144,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Friday',
    hr: '6 pm',
    count: 182,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Friday',
    hr: '7 pm',
    count: 233,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Friday',
    hr: '8 pm',
    count: 218,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Friday',
    hr: '9 pm',
    count: 246,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Friday',
    hr: '10 pm',
    count: 266,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Friday',
    hr: '11 pm',
    count: 254,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Friday',
    hr: '12 am',
    count: 233,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Friday',
    hr: '1 am',
    count: 145,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Friday',
    hr: '2 am',
    count: 99,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Friday',
    hr: '3 am',
    count: 80,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Friday',
    hr: '4 am',
    count: 37,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Friday',
    hr: '5 am',
    count: 22,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Saturday',
    hr: '6 am',
    count: 39,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Saturday',
    hr: '7 am',
    count: 33,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Saturday',
    hr: '8 am',
    count: 37,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Saturday',
    hr: '9 am',
    count: 32,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Saturday',
    hr: '10 am',
    count: 36,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Saturday',
    hr: '11 am',
    count: 41,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Saturday',
    hr: '12 pm',
    count: 26,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Saturday',
    hr: '1 pm',
    count: 37,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Saturday',
    hr: '2 pm',
    count: 50,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Saturday',
    hr: '3 pm',
    count: 32,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Saturday',
    hr: '4 pm',
    count: 49,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Saturday',
    hr: '5 pm',
    count: 54,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Saturday',
    hr: '6 pm',
    count: 108,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Saturday',
    hr: '7 pm',
    count: 134,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Saturday',
    hr: '8 pm',
    count: 105,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Saturday',
    hr: '9 pm',
    count: 179,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Saturday',
    hr: '10 pm',
    count: 195,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Saturday',
    hr: '11 pm',
    count: 185,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Saturday',
    hr: '12 am',
    count: 264,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Saturday',
    hr: '1 am',
    count: 246,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Saturday',
    hr: '2 am',
    count: 182,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Saturday',
    hr: '3 am',
    count: 114,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Saturday',
    hr: '4 am',
    count: 58,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Saturday',
    hr: '5 am',
    count: 36,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Sunday',
    hr: '6 am',
    count: 26,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Sunday',
    hr: '7 am',
    count: 13,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Sunday',
    hr: '8 am',
    count: 17,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Sunday',
    hr: '9 am',
    count: 27,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Sunday',
    hr: '10 am',
    count: 28,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Sunday',
    hr: '11 am',
    count: 30,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Sunday',
    hr: '12 pm',
    count: 23,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Sunday',
    hr: '1 pm',
    count: 32,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Sunday',
    hr: '2 pm',
    count: 23,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Sunday',
    hr: '3 pm',
    count: 36,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Sunday',
    hr: '4 pm',
    count: 31,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Sunday',
    hr: '5 pm',
    count: 48,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Sunday',
    hr: '6 pm',
    count: 77,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Sunday',
    hr: '7 pm',
    count: 81,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Sunday',
    hr: '8 pm',
    count: 88,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Sunday',
    hr: '9 pm',
    count: 113,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Sunday',
    hr: '10 pm',
    count: 123,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Sunday',
    hr: '11 pm',
    count: 159,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Sunday',
    hr: '12 am',
    count: 215,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Sunday',
    hr: '1 am',
    count: 160,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Sunday',
    hr: '2 am',
    count: 119,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Sunday',
    hr: '3 am',
    count: 87,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Sunday',
    hr: '4 am',
    count: 63,
  },
  {
    offenseCategory: 'Narcotics',
    dow: 'Sunday',
    hr: '5 am',
    count: 44,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Monday',
    hr: '6 am',
    count: 21,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Monday',
    hr: '7 am',
    count: 35,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Monday',
    hr: '8 am',
    count: 52,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Monday',
    hr: '9 am',
    count: 78,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Monday',
    hr: '10 am',
    count: 64,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Monday',
    hr: '11 am',
    count: 108,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Monday',
    hr: '12 pm',
    count: 99,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Monday',
    hr: '1 pm',
    count: 91,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Monday',
    hr: '2 pm',
    count: 126,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Monday',
    hr: '3 pm',
    count: 124,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Monday',
    hr: '4 pm',
    count: 137,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Monday',
    hr: '5 pm',
    count: 134,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Monday',
    hr: '6 pm',
    count: 142,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Monday',
    hr: '7 pm',
    count: 122,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Monday',
    hr: '8 pm',
    count: 116,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Monday',
    hr: '9 pm',
    count: 136,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Monday',
    hr: '10 pm',
    count: 124,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Monday',
    hr: '11 pm',
    count: 96,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Monday',
    hr: '12 am',
    count: 105,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Monday',
    hr: '1 am',
    count: 116,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Monday',
    hr: '2 am',
    count: 186,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Monday',
    hr: '3 am',
    count: 80,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Monday',
    hr: '4 am',
    count: 29,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Monday',
    hr: '5 am',
    count: 25,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Tuesday',
    hr: '6 am',
    count: 26,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Tuesday',
    hr: '7 am',
    count: 29,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Tuesday',
    hr: '8 am',
    count: 56,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Tuesday',
    hr: '9 am',
    count: 76,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Tuesday',
    hr: '10 am',
    count: 78,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Tuesday',
    hr: '11 am',
    count: 72,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Tuesday',
    hr: '12 pm',
    count: 101,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Tuesday',
    hr: '1 pm',
    count: 106,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Tuesday',
    hr: '2 pm',
    count: 116,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Tuesday',
    hr: '3 pm',
    count: 124,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Tuesday',
    hr: '4 pm',
    count: 118,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Tuesday',
    hr: '5 pm',
    count: 119,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Tuesday',
    hr: '6 pm',
    count: 121,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Tuesday',
    hr: '7 pm',
    count: 123,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Tuesday',
    hr: '8 pm',
    count: 122,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Tuesday',
    hr: '9 pm',
    count: 112,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Tuesday',
    hr: '10 pm',
    count: 104,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Tuesday',
    hr: '11 pm',
    count: 97,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Tuesday',
    hr: '12 am',
    count: 86,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Tuesday',
    hr: '1 am',
    count: 77,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Tuesday',
    hr: '2 am',
    count: 72,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Tuesday',
    hr: '3 am',
    count: 52,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Tuesday',
    hr: '4 am',
    count: 27,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Tuesday',
    hr: '5 am',
    count: 27,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Wednesday',
    hr: '6 am',
    count: 20,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Wednesday',
    hr: '7 am',
    count: 36,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Wednesday',
    hr: '8 am',
    count: 57,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Wednesday',
    hr: '9 am',
    count: 75,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Wednesday',
    hr: '10 am',
    count: 90,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Wednesday',
    hr: '11 am',
    count: 80,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Wednesday',
    hr: '12 pm',
    count: 92,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Wednesday',
    hr: '1 pm',
    count: 106,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Wednesday',
    hr: '2 pm',
    count: 124,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Wednesday',
    hr: '3 pm',
    count: 137,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Wednesday',
    hr: '4 pm',
    count: 133,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Wednesday',
    hr: '5 pm',
    count: 124,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Wednesday',
    hr: '6 pm',
    count: 120,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Wednesday',
    hr: '7 pm',
    count: 133,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Wednesday',
    hr: '8 pm',
    count: 123,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Wednesday',
    hr: '9 pm',
    count: 105,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Wednesday',
    hr: '10 pm',
    count: 119,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Wednesday',
    hr: '11 pm',
    count: 101,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Wednesday',
    hr: '12 am',
    count: 100,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Wednesday',
    hr: '1 am',
    count: 118,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Wednesday',
    hr: '2 am',
    count: 176,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Wednesday',
    hr: '3 am',
    count: 58,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Wednesday',
    hr: '4 am',
    count: 31,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Wednesday',
    hr: '5 am',
    count: 20,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Thursday',
    hr: '6 am',
    count: 30,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Thursday',
    hr: '7 am',
    count: 39,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Thursday',
    hr: '8 am',
    count: 59,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Thursday',
    hr: '9 am',
    count: 57,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Thursday',
    hr: '10 am',
    count: 84,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Thursday',
    hr: '11 am',
    count: 66,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Thursday',
    hr: '12 pm',
    count: 96,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Thursday',
    hr: '1 pm',
    count: 90,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Thursday',
    hr: '2 pm',
    count: 101,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Thursday',
    hr: '3 pm',
    count: 123,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Thursday',
    hr: '4 pm',
    count: 129,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Thursday',
    hr: '5 pm',
    count: 107,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Thursday',
    hr: '6 pm',
    count: 115,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Thursday',
    hr: '7 pm',
    count: 113,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Thursday',
    hr: '8 pm',
    count: 127,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Thursday',
    hr: '9 pm',
    count: 111,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Thursday',
    hr: '10 pm',
    count: 89,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Thursday',
    hr: '11 pm',
    count: 123,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Thursday',
    hr: '12 am',
    count: 92,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Thursday',
    hr: '1 am',
    count: 118,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Thursday',
    hr: '2 am',
    count: 177,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Thursday',
    hr: '3 am',
    count: 76,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Thursday',
    hr: '4 am',
    count: 33,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Thursday',
    hr: '5 am',
    count: 24,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Friday',
    hr: '6 am',
    count: 27,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Friday',
    hr: '7 am',
    count: 39,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Friday',
    hr: '8 am',
    count: 62,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Friday',
    hr: '9 am',
    count: 90,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Friday',
    hr: '10 am',
    count: 81,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Friday',
    hr: '11 am',
    count: 92,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Friday',
    hr: '12 pm',
    count: 99,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Friday',
    hr: '1 pm',
    count: 108,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Friday',
    hr: '2 pm',
    count: 109,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Friday',
    hr: '3 pm',
    count: 122,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Friday',
    hr: '4 pm',
    count: 122,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Friday',
    hr: '5 pm',
    count: 141,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Friday',
    hr: '6 pm',
    count: 118,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Friday',
    hr: '7 pm',
    count: 139,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Friday',
    hr: '8 pm',
    count: 127,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Friday',
    hr: '9 pm',
    count: 109,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Friday',
    hr: '10 pm',
    count: 154,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Friday',
    hr: '11 pm',
    count: 134,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Friday',
    hr: '12 am',
    count: 113,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Friday',
    hr: '1 am',
    count: 143,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Friday',
    hr: '2 am',
    count: 207,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Friday',
    hr: '3 am',
    count: 100,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Friday',
    hr: '4 am',
    count: 38,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Friday',
    hr: '5 am',
    count: 26,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Saturday',
    hr: '6 am',
    count: 32,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Saturday',
    hr: '7 am',
    count: 24,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Saturday',
    hr: '8 am',
    count: 32,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Saturday',
    hr: '9 am',
    count: 39,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Saturday',
    hr: '10 am',
    count: 67,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Saturday',
    hr: '11 am',
    count: 82,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Saturday',
    hr: '12 pm',
    count: 79,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Saturday',
    hr: '1 pm',
    count: 87,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Saturday',
    hr: '2 pm',
    count: 88,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Saturday',
    hr: '3 pm',
    count: 118,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Saturday',
    hr: '4 pm',
    count: 94,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Saturday',
    hr: '5 pm',
    count: 104,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Saturday',
    hr: '6 pm',
    count: 119,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Saturday',
    hr: '7 pm',
    count: 137,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Saturday',
    hr: '8 pm',
    count: 152,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Saturday',
    hr: '9 pm',
    count: 159,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Saturday',
    hr: '10 pm',
    count: 165,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Saturday',
    hr: '11 pm',
    count: 172,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Saturday',
    hr: '12 am',
    count: 207,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Saturday',
    hr: '1 am',
    count: 248,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Saturday',
    hr: '2 am',
    count: 405,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Saturday',
    hr: '3 am',
    count: 186,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Saturday',
    hr: '4 am',
    count: 72,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Saturday',
    hr: '5 am',
    count: 44,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Sunday',
    hr: '6 am',
    count: 32,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Sunday',
    hr: '7 am',
    count: 28,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Sunday',
    hr: '8 am',
    count: 31,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Sunday',
    hr: '9 am',
    count: 32,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Sunday',
    hr: '10 am',
    count: 46,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Sunday',
    hr: '11 am',
    count: 60,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Sunday',
    hr: '12 pm',
    count: 60,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Sunday',
    hr: '1 pm',
    count: 75,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Sunday',
    hr: '2 pm',
    count: 78,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Sunday',
    hr: '3 pm',
    count: 85,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Sunday',
    hr: '4 pm',
    count: 107,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Sunday',
    hr: '5 pm',
    count: 105,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Sunday',
    hr: '6 pm',
    count: 146,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Sunday',
    hr: '7 pm',
    count: 144,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Sunday',
    hr: '8 pm',
    count: 128,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Sunday',
    hr: '9 pm',
    count: 132,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Sunday',
    hr: '10 pm',
    count: 104,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Sunday',
    hr: '11 pm',
    count: 126,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Sunday',
    hr: '12 am',
    count: 196,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Sunday',
    hr: '1 am',
    count: 307,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Sunday',
    hr: '2 am',
    count: 431,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Sunday',
    hr: '3 am',
    count: 204,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Sunday',
    hr: '4 am',
    count: 72,
  },
  {
    offenseCategory: 'Assault',
    dow: 'Sunday',
    hr: '5 am',
    count: 41,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Monday',
    hr: '6 am',
    count: 5,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Monday',
    hr: '7 am',
    count: 15,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Monday',
    hr: '8 am',
    count: 94,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Monday',
    hr: '9 am',
    count: 156,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Monday',
    hr: '10 am',
    count: 211,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Monday',
    hr: '11 am',
    count: 228,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Monday',
    hr: '12 pm',
    count: 192,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Monday',
    hr: '1 pm',
    count: 174,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Monday',
    hr: '2 pm',
    count: 214,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Monday',
    hr: '3 pm',
    count: 178,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Monday',
    hr: '4 pm',
    count: 149,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Monday',
    hr: '5 pm',
    count: 69,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Monday',
    hr: '6 pm',
    count: 64,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Monday',
    hr: '7 pm',
    count: 34,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Monday',
    hr: '8 pm',
    count: 26,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Monday',
    hr: '9 pm',
    count: 31,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Monday',
    hr: '10 pm',
    count: 24,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Monday',
    hr: '11 pm',
    count: 12,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Monday',
    hr: '12 am',
    count: 11,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Monday',
    hr: '1 am',
    count: 7,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Monday',
    hr: '2 am',
    count: 6,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Monday',
    hr: '3 am',
    count: 4,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Monday',
    hr: '4 am',
    count: 5,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Monday',
    hr: '5 am',
    count: 2,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Tuesday',
    hr: '6 am',
    count: 3,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Tuesday',
    hr: '7 am',
    count: 13,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Tuesday',
    hr: '8 am',
    count: 93,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Tuesday',
    hr: '9 am',
    count: 172,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Tuesday',
    hr: '10 am',
    count: 211,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Tuesday',
    hr: '11 am',
    count: 214,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Tuesday',
    hr: '12 pm',
    count: 184,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Tuesday',
    hr: '1 pm',
    count: 204,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Tuesday',
    hr: '2 pm',
    count: 208,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Tuesday',
    hr: '3 pm',
    count: 218,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Tuesday',
    hr: '4 pm',
    count: 146,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Tuesday',
    hr: '5 pm',
    count: 82,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Tuesday',
    hr: '6 pm',
    count: 66,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Tuesday',
    hr: '7 pm',
    count: 49,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Tuesday',
    hr: '8 pm',
    count: 30,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Tuesday',
    hr: '9 pm',
    count: 26,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Tuesday',
    hr: '10 pm',
    count: 18,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Tuesday',
    hr: '11 pm',
    count: 20,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Tuesday',
    hr: '12 am',
    count: 5,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Tuesday',
    hr: '1 am',
    count: 7,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Tuesday',
    hr: '2 am',
    count: 6,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Tuesday',
    hr: '3 am',
    count: 3,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Tuesday',
    hr: '4 am',
    count: 2,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Tuesday',
    hr: '5 am',
    count: 4,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Wednesday',
    hr: '6 am',
    count: 7,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Wednesday',
    hr: '7 am',
    count: 21,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Wednesday',
    hr: '8 am',
    count: 80,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Wednesday',
    hr: '9 am',
    count: 166,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Wednesday',
    hr: '10 am',
    count: 215,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Wednesday',
    hr: '11 am',
    count: 195,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Wednesday',
    hr: '12 pm',
    count: 182,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Wednesday',
    hr: '1 pm',
    count: 192,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Wednesday',
    hr: '2 pm',
    count: 208,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Wednesday',
    hr: '3 pm',
    count: 181,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Wednesday',
    hr: '4 pm',
    count: 151,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Wednesday',
    hr: '5 pm',
    count: 81,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Wednesday',
    hr: '6 pm',
    count: 57,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Wednesday',
    hr: '7 pm',
    count: 37,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Wednesday',
    hr: '8 pm',
    count: 31,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Wednesday',
    hr: '9 pm',
    count: 35,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Wednesday',
    hr: '10 pm',
    count: 18,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Wednesday',
    hr: '11 pm',
    count: 17,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Wednesday',
    hr: '12 am',
    count: 9,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Wednesday',
    hr: '1 am',
    count: 8,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Wednesday',
    hr: '2 am',
    count: 7,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Wednesday',
    hr: '3 am',
    count: 4,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Wednesday',
    hr: '4 am',
    count: 0,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Wednesday',
    hr: '5 am',
    count: 2,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Thursday',
    hr: '6 am',
    count: 4,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Thursday',
    hr: '7 am',
    count: 22,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Thursday',
    hr: '8 am',
    count: 65,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Thursday',
    hr: '9 am',
    count: 170,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Thursday',
    hr: '10 am',
    count: 209,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Thursday',
    hr: '11 am',
    count: 197,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Thursday',
    hr: '12 pm',
    count: 183,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Thursday',
    hr: '1 pm',
    count: 220,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Thursday',
    hr: '2 pm',
    count: 169,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Thursday',
    hr: '3 pm',
    count: 189,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Thursday',
    hr: '4 pm',
    count: 166,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Thursday',
    hr: '5 pm',
    count: 92,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Thursday',
    hr: '6 pm',
    count: 58,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Thursday',
    hr: '7 pm',
    count: 43,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Thursday',
    hr: '8 pm',
    count: 32,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Thursday',
    hr: '9 pm',
    count: 22,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Thursday',
    hr: '10 pm',
    count: 19,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Thursday',
    hr: '11 pm',
    count: 16,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Thursday',
    hr: '12 am',
    count: 10,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Thursday',
    hr: '1 am',
    count: 7,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Thursday',
    hr: '2 am',
    count: 8,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Thursday',
    hr: '3 am',
    count: 3,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Thursday',
    hr: '4 am',
    count: 8,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Thursday',
    hr: '5 am',
    count: 2,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Friday',
    hr: '6 am',
    count: 2,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Friday',
    hr: '7 am',
    count: 15,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Friday',
    hr: '8 am',
    count: 80,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Friday',
    hr: '9 am',
    count: 138,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Friday',
    hr: '10 am',
    count: 159,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Friday',
    hr: '11 am',
    count: 172,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Friday',
    hr: '12 pm',
    count: 175,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Friday',
    hr: '1 pm',
    count: 159,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Friday',
    hr: '2 pm',
    count: 207,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Friday',
    hr: '3 pm',
    count: 169,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Friday',
    hr: '4 pm',
    count: 141,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Friday',
    hr: '5 pm',
    count: 73,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Friday',
    hr: '6 pm',
    count: 63,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Friday',
    hr: '7 pm',
    count: 32,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Friday',
    hr: '8 pm',
    count: 36,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Friday',
    hr: '9 pm',
    count: 20,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Friday',
    hr: '10 pm',
    count: 24,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Friday',
    hr: '11 pm',
    count: 18,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Friday',
    hr: '12 am',
    count: 11,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Friday',
    hr: '1 am',
    count: 9,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Friday',
    hr: '2 am',
    count: 7,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Friday',
    hr: '3 am',
    count: 2,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Friday',
    hr: '4 am',
    count: 3,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Friday',
    hr: '5 am',
    count: 3,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Saturday',
    hr: '6 am',
    count: 5,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Saturday',
    hr: '7 am',
    count: 4,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Saturday',
    hr: '8 am',
    count: 17,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Saturday',
    hr: '9 am',
    count: 22,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Saturday',
    hr: '10 am',
    count: 35,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Saturday',
    hr: '11 am',
    count: 42,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Saturday',
    hr: '12 pm',
    count: 39,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Saturday',
    hr: '1 pm',
    count: 38,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Saturday',
    hr: '2 pm',
    count: 31,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Saturday',
    hr: '3 pm',
    count: 37,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Saturday',
    hr: '4 pm',
    count: 37,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Saturday',
    hr: '5 pm',
    count: 29,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Saturday',
    hr: '6 pm',
    count: 30,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Saturday',
    hr: '7 pm',
    count: 24,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Saturday',
    hr: '8 pm',
    count: 29,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Saturday',
    hr: '9 pm',
    count: 28,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Saturday',
    hr: '10 pm',
    count: 20,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Saturday',
    hr: '11 pm',
    count: 24,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Saturday',
    hr: '12 am',
    count: 14,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Saturday',
    hr: '1 am',
    count: 16,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Saturday',
    hr: '2 am',
    count: 11,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Saturday',
    hr: '3 am',
    count: 9,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Saturday',
    hr: '4 am',
    count: 12,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Saturday',
    hr: '5 am',
    count: 3,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Sunday',
    hr: '6 am',
    count: 6,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Sunday',
    hr: '7 am',
    count: 5,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Sunday',
    hr: '8 am',
    count: 7,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Sunday',
    hr: '9 am',
    count: 20,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Sunday',
    hr: '10 am',
    count: 22,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Sunday',
    hr: '11 am',
    count: 20,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Sunday',
    hr: '12 pm',
    count: 21,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Sunday',
    hr: '1 pm',
    count: 25,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Sunday',
    hr: '2 pm',
    count: 26,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Sunday',
    hr: '3 pm',
    count: 29,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Sunday',
    hr: '4 pm',
    count: 19,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Sunday',
    hr: '5 pm',
    count: 23,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Sunday',
    hr: '6 pm',
    count: 19,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Sunday',
    hr: '7 pm',
    count: 20,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Sunday',
    hr: '8 pm',
    count: 24,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Sunday',
    hr: '9 pm',
    count: 15,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Sunday',
    hr: '10 pm',
    count: 13,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Sunday',
    hr: '11 pm',
    count: 14,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Sunday',
    hr: '12 am',
    count: 13,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Sunday',
    hr: '1 am',
    count: 17,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Sunday',
    hr: '2 am',
    count: 9,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Sunday',
    hr: '3 am',
    count: 6,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Sunday',
    hr: '4 am',
    count: 8,
  },
  {
    offenseCategory: 'Fraud',
    dow: 'Sunday',
    hr: '5 am',
    count: 4,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Monday',
    hr: '6 am',
    count: 75,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Monday',
    hr: '7 am',
    count: 105,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Monday',
    hr: '8 am',
    count: 131,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Monday',
    hr: '9 am',
    count: 123,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Monday',
    hr: '10 am',
    count: 72,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Monday',
    hr: '11 am',
    count: 94,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Monday',
    hr: '12 pm',
    count: 66,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Monday',
    hr: '1 pm',
    count: 61,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Monday',
    hr: '2 pm',
    count: 47,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Monday',
    hr: '3 pm',
    count: 37,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Monday',
    hr: '4 pm',
    count: 37,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Monday',
    hr: '5 pm',
    count: 44,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Monday',
    hr: '6 pm',
    count: 44,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Monday',
    hr: '7 pm',
    count: 40,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Monday',
    hr: '8 pm',
    count: 27,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Monday',
    hr: '9 pm',
    count: 34,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Monday',
    hr: '10 pm',
    count: 31,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Monday',
    hr: '11 pm',
    count: 23,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Monday',
    hr: '12 am',
    count: 25,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Monday',
    hr: '1 am',
    count: 20,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Monday',
    hr: '2 am',
    count: 26,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Monday',
    hr: '3 am',
    count: 35,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Monday',
    hr: '4 am',
    count: 24,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Monday',
    hr: '5 am',
    count: 27,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Tuesday',
    hr: '6 am',
    count: 70,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Tuesday',
    hr: '7 am',
    count: 115,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Tuesday',
    hr: '8 am',
    count: 100,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Tuesday',
    hr: '9 am',
    count: 91,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Tuesday',
    hr: '10 am',
    count: 79,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Tuesday',
    hr: '11 am',
    count: 69,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Tuesday',
    hr: '12 pm',
    count: 75,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Tuesday',
    hr: '1 pm',
    count: 56,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Tuesday',
    hr: '2 pm',
    count: 56,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Tuesday',
    hr: '3 pm',
    count: 47,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Tuesday',
    hr: '4 pm',
    count: 50,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Tuesday',
    hr: '5 pm',
    count: 35,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Tuesday',
    hr: '6 pm',
    count: 44,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Tuesday',
    hr: '7 pm',
    count: 27,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Tuesday',
    hr: '8 pm',
    count: 22,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Tuesday',
    hr: '9 pm',
    count: 27,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Tuesday',
    hr: '10 pm',
    count: 24,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Tuesday',
    hr: '11 pm',
    count: 26,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Tuesday',
    hr: '12 am',
    count: 23,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Tuesday',
    hr: '1 am',
    count: 20,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Tuesday',
    hr: '2 am',
    count: 14,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Tuesday',
    hr: '3 am',
    count: 23,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Tuesday',
    hr: '4 am',
    count: 21,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Tuesday',
    hr: '5 am',
    count: 33,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Wednesday',
    hr: '6 am',
    count: 60,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Wednesday',
    hr: '7 am',
    count: 95,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Wednesday',
    hr: '8 am',
    count: 98,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Wednesday',
    hr: '9 am',
    count: 74,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Wednesday',
    hr: '10 am',
    count: 68,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Wednesday',
    hr: '11 am',
    count: 56,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Wednesday',
    hr: '12 pm',
    count: 53,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Wednesday',
    hr: '1 pm',
    count: 64,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Wednesday',
    hr: '2 pm',
    count: 54,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Wednesday',
    hr: '3 pm',
    count: 62,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Wednesday',
    hr: '4 pm',
    count: 44,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Wednesday',
    hr: '5 pm',
    count: 35,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Wednesday',
    hr: '6 pm',
    count: 36,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Wednesday',
    hr: '7 pm',
    count: 28,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Wednesday',
    hr: '8 pm',
    count: 30,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Wednesday',
    hr: '9 pm',
    count: 27,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Wednesday',
    hr: '10 pm',
    count: 27,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Wednesday',
    hr: '11 pm',
    count: 21,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Wednesday',
    hr: '12 am',
    count: 22,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Wednesday',
    hr: '1 am',
    count: 30,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Wednesday',
    hr: '2 am',
    count: 17,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Wednesday',
    hr: '3 am',
    count: 18,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Wednesday',
    hr: '4 am',
    count: 21,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Wednesday',
    hr: '5 am',
    count: 17,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Thursday',
    hr: '6 am',
    count: 76,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Thursday',
    hr: '7 am',
    count: 91,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Thursday',
    hr: '8 am',
    count: 85,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Thursday',
    hr: '9 am',
    count: 91,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Thursday',
    hr: '10 am',
    count: 80,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Thursday',
    hr: '11 am',
    count: 61,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Thursday',
    hr: '12 pm',
    count: 47,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Thursday',
    hr: '1 pm',
    count: 62,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Thursday',
    hr: '2 pm',
    count: 46,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Thursday',
    hr: '3 pm',
    count: 54,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Thursday',
    hr: '4 pm',
    count: 37,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Thursday',
    hr: '5 pm',
    count: 37,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Thursday',
    hr: '6 pm',
    count: 36,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Thursday',
    hr: '7 pm',
    count: 28,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Thursday',
    hr: '8 pm',
    count: 28,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Thursday',
    hr: '9 pm',
    count: 16,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Thursday',
    hr: '10 pm',
    count: 23,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Thursday',
    hr: '11 pm',
    count: 24,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Thursday',
    hr: '12 am',
    count: 28,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Thursday',
    hr: '1 am',
    count: 22,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Thursday',
    hr: '2 am',
    count: 15,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Thursday',
    hr: '3 am',
    count: 18,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Thursday',
    hr: '4 am',
    count: 20,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Thursday',
    hr: '5 am',
    count: 35,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Friday',
    hr: '6 am',
    count: 53,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Friday',
    hr: '7 am',
    count: 95,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Friday',
    hr: '8 am',
    count: 88,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Friday',
    hr: '9 am',
    count: 99,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Friday',
    hr: '10 am',
    count: 79,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Friday',
    hr: '11 am',
    count: 56,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Friday',
    hr: '12 pm',
    count: 55,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Friday',
    hr: '1 pm',
    count: 68,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Friday',
    hr: '2 pm',
    count: 58,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Friday',
    hr: '3 pm',
    count: 59,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Friday',
    hr: '4 pm',
    count: 30,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Friday',
    hr: '5 pm',
    count: 35,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Friday',
    hr: '6 pm',
    count: 32,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Friday',
    hr: '7 pm',
    count: 25,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Friday',
    hr: '8 pm',
    count: 25,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Friday',
    hr: '9 pm',
    count: 26,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Friday',
    hr: '10 pm',
    count: 31,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Friday',
    hr: '11 pm',
    count: 41,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Friday',
    hr: '12 am',
    count: 24,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Friday',
    hr: '1 am',
    count: 28,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Friday',
    hr: '2 am',
    count: 24,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Friday',
    hr: '3 am',
    count: 25,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Friday',
    hr: '4 am',
    count: 27,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Friday',
    hr: '5 am',
    count: 44,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Saturday',
    hr: '6 am',
    count: 43,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Saturday',
    hr: '7 am',
    count: 58,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Saturday',
    hr: '8 am',
    count: 85,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Saturday',
    hr: '9 am',
    count: 80,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Saturday',
    hr: '10 am',
    count: 68,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Saturday',
    hr: '11 am',
    count: 64,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Saturday',
    hr: '12 pm',
    count: 55,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Saturday',
    hr: '1 pm',
    count: 48,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Saturday',
    hr: '2 pm',
    count: 38,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Saturday',
    hr: '3 pm',
    count: 39,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Saturday',
    hr: '4 pm',
    count: 31,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Saturday',
    hr: '5 pm',
    count: 30,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Saturday',
    hr: '6 pm',
    count: 32,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Saturday',
    hr: '7 pm',
    count: 28,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Saturday',
    hr: '8 pm',
    count: 33,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Saturday',
    hr: '9 pm',
    count: 38,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Saturday',
    hr: '10 pm',
    count: 42,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Saturday',
    hr: '11 pm',
    count: 30,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Saturday',
    hr: '12 am',
    count: 24,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Saturday',
    hr: '1 am',
    count: 35,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Saturday',
    hr: '2 am',
    count: 22,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Saturday',
    hr: '3 am',
    count: 35,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Saturday',
    hr: '4 am',
    count: 26,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Saturday',
    hr: '5 am',
    count: 20,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Sunday',
    hr: '6 am',
    count: 36,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Sunday',
    hr: '7 am',
    count: 44,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Sunday',
    hr: '8 am',
    count: 57,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Sunday',
    hr: '9 am',
    count: 66,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Sunday',
    hr: '10 am',
    count: 84,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Sunday',
    hr: '11 am',
    count: 72,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Sunday',
    hr: '12 pm',
    count: 66,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Sunday',
    hr: '1 pm',
    count: 51,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Sunday',
    hr: '2 pm',
    count: 34,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Sunday',
    hr: '3 pm',
    count: 34,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Sunday',
    hr: '4 pm',
    count: 37,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Sunday',
    hr: '5 pm',
    count: 31,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Sunday',
    hr: '6 pm',
    count: 40,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Sunday',
    hr: '7 pm',
    count: 44,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Sunday',
    hr: '8 pm',
    count: 28,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Sunday',
    hr: '9 pm',
    count: 31,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Sunday',
    hr: '10 pm',
    count: 35,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Sunday',
    hr: '11 pm',
    count: 26,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Sunday',
    hr: '12 am',
    count: 37,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Sunday',
    hr: '1 am',
    count: 34,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Sunday',
    hr: '2 am',
    count: 30,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Sunday',
    hr: '3 am',
    count: 28,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Sunday',
    hr: '4 am',
    count: 29,
  },
  {
    offenseCategory: 'Vehicle Theft',
    dow: 'Sunday',
    hr: '5 am',
    count: 20,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Monday',
    hr: '6 am',
    count: 21,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Monday',
    hr: '7 am',
    count: 10,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Monday',
    hr: '8 am',
    count: 13,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Monday',
    hr: '9 am',
    count: 16,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Monday',
    hr: '10 am',
    count: 23,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Monday',
    hr: '11 am',
    count: 32,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Monday',
    hr: '12 pm',
    count: 37,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Monday',
    hr: '1 pm',
    count: 32,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Monday',
    hr: '2 pm',
    count: 31,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Monday',
    hr: '3 pm',
    count: 24,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Monday',
    hr: '4 pm',
    count: 27,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Monday',
    hr: '5 pm',
    count: 30,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Monday',
    hr: '6 pm',
    count: 16,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Monday',
    hr: '7 pm',
    count: 33,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Monday',
    hr: '8 pm',
    count: 50,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Monday',
    hr: '9 pm',
    count: 54,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Monday',
    hr: '10 pm',
    count: 46,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Monday',
    hr: '11 pm',
    count: 42,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Monday',
    hr: '12 am',
    count: 41,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Monday',
    hr: '1 am',
    count: 44,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Monday',
    hr: '2 am',
    count: 21,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Monday',
    hr: '3 am',
    count: 28,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Monday',
    hr: '4 am',
    count: 19,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Monday',
    hr: '5 am',
    count: 20,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Tuesday',
    hr: '6 am',
    count: 15,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Tuesday',
    hr: '7 am',
    count: 10,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Tuesday',
    hr: '8 am',
    count: 16,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Tuesday',
    hr: '9 am',
    count: 17,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Tuesday',
    hr: '10 am',
    count: 17,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Tuesday',
    hr: '11 am',
    count: 18,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Tuesday',
    hr: '12 pm',
    count: 26,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Tuesday',
    hr: '1 pm',
    count: 22,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Tuesday',
    hr: '2 pm',
    count: 34,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Tuesday',
    hr: '3 pm',
    count: 29,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Tuesday',
    hr: '4 pm',
    count: 25,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Tuesday',
    hr: '5 pm',
    count: 26,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Tuesday',
    hr: '6 pm',
    count: 26,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Tuesday',
    hr: '7 pm',
    count: 33,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Tuesday',
    hr: '8 pm',
    count: 24,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Tuesday',
    hr: '9 pm',
    count: 38,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Tuesday',
    hr: '10 pm',
    count: 41,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Tuesday',
    hr: '11 pm',
    count: 31,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Tuesday',
    hr: '12 am',
    count: 33,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Tuesday',
    hr: '1 am',
    count: 35,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Tuesday',
    hr: '2 am',
    count: 29,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Tuesday',
    hr: '3 am',
    count: 18,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Tuesday',
    hr: '4 am',
    count: 11,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Tuesday',
    hr: '5 am',
    count: 12,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Wednesday',
    hr: '6 am',
    count: 11,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Wednesday',
    hr: '7 am',
    count: 6,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Wednesday',
    hr: '8 am',
    count: 14,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Wednesday',
    hr: '9 am',
    count: 11,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Wednesday',
    hr: '10 am',
    count: 21,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Wednesday',
    hr: '11 am',
    count: 20,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Wednesday',
    hr: '12 pm',
    count: 22,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Wednesday',
    hr: '1 pm',
    count: 29,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Wednesday',
    hr: '2 pm',
    count: 19,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Wednesday',
    hr: '3 pm',
    count: 28,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Wednesday',
    hr: '4 pm',
    count: 26,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Wednesday',
    hr: '5 pm',
    count: 19,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Wednesday',
    hr: '6 pm',
    count: 23,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Wednesday',
    hr: '7 pm',
    count: 33,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Wednesday',
    hr: '8 pm',
    count: 38,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Wednesday',
    hr: '9 pm',
    count: 48,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Wednesday',
    hr: '10 pm',
    count: 42,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Wednesday',
    hr: '11 pm',
    count: 48,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Wednesday',
    hr: '12 am',
    count: 35,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Wednesday',
    hr: '1 am',
    count: 32,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Wednesday',
    hr: '2 am',
    count: 36,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Wednesday',
    hr: '3 am',
    count: 26,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Wednesday',
    hr: '4 am',
    count: 9,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Wednesday',
    hr: '5 am',
    count: 22,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Thursday',
    hr: '6 am',
    count: 10,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Thursday',
    hr: '7 am',
    count: 10,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Thursday',
    hr: '8 am',
    count: 15,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Thursday',
    hr: '9 am',
    count: 23,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Thursday',
    hr: '10 am',
    count: 23,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Thursday',
    hr: '11 am',
    count: 19,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Thursday',
    hr: '12 pm',
    count: 23,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Thursday',
    hr: '1 pm',
    count: 30,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Thursday',
    hr: '2 pm',
    count: 17,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Thursday',
    hr: '3 pm',
    count: 26,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Thursday',
    hr: '4 pm',
    count: 26,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Thursday',
    hr: '5 pm',
    count: 21,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Thursday',
    hr: '6 pm',
    count: 31,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Thursday',
    hr: '7 pm',
    count: 28,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Thursday',
    hr: '8 pm',
    count: 42,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Thursday',
    hr: '9 pm',
    count: 48,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Thursday',
    hr: '10 pm',
    count: 54,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Thursday',
    hr: '11 pm',
    count: 27,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Thursday',
    hr: '12 am',
    count: 35,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Thursday',
    hr: '1 am',
    count: 43,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Thursday',
    hr: '2 am',
    count: 30,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Thursday',
    hr: '3 am',
    count: 28,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Thursday',
    hr: '4 am',
    count: 14,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Thursday',
    hr: '5 am',
    count: 18,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Friday',
    hr: '6 am',
    count: 15,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Friday',
    hr: '7 am',
    count: 15,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Friday',
    hr: '8 am',
    count: 6,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Friday',
    hr: '9 am',
    count: 16,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Friday',
    hr: '10 am',
    count: 21,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Friday',
    hr: '11 am',
    count: 25,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Friday',
    hr: '12 pm',
    count: 20,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Friday',
    hr: '1 pm',
    count: 21,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Friday',
    hr: '2 pm',
    count: 21,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Friday',
    hr: '3 pm',
    count: 27,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Friday',
    hr: '4 pm',
    count: 28,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Friday',
    hr: '5 pm',
    count: 28,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Friday',
    hr: '6 pm',
    count: 33,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Friday',
    hr: '7 pm',
    count: 40,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Friday',
    hr: '8 pm',
    count: 42,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Friday',
    hr: '9 pm',
    count: 45,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Friday',
    hr: '10 pm',
    count: 39,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Friday',
    hr: '11 pm',
    count: 47,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Friday',
    hr: '12 am',
    count: 31,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Friday',
    hr: '1 am',
    count: 34,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Friday',
    hr: '2 am',
    count: 34,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Friday',
    hr: '3 am',
    count: 36,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Friday',
    hr: '4 am',
    count: 22,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Friday',
    hr: '5 am',
    count: 8,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Saturday',
    hr: '6 am',
    count: 22,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Saturday',
    hr: '7 am',
    count: 20,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Saturday',
    hr: '8 am',
    count: 6,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Saturday',
    hr: '9 am',
    count: 23,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Saturday',
    hr: '10 am',
    count: 12,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Saturday',
    hr: '11 am',
    count: 16,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Saturday',
    hr: '12 pm',
    count: 16,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Saturday',
    hr: '1 pm',
    count: 19,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Saturday',
    hr: '2 pm',
    count: 20,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Saturday',
    hr: '3 pm',
    count: 17,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Saturday',
    hr: '4 pm',
    count: 20,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Saturday',
    hr: '5 pm',
    count: 28,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Saturday',
    hr: '6 pm',
    count: 33,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Saturday',
    hr: '7 pm',
    count: 40,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Saturday',
    hr: '8 pm',
    count: 37,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Saturday',
    hr: '9 pm',
    count: 44,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Saturday',
    hr: '10 pm',
    count: 45,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Saturday',
    hr: '11 pm',
    count: 41,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Saturday',
    hr: '12 am',
    count: 48,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Saturday',
    hr: '1 am',
    count: 46,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Saturday',
    hr: '2 am',
    count: 60,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Saturday',
    hr: '3 am',
    count: 43,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Saturday',
    hr: '4 am',
    count: 34,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Saturday',
    hr: '5 am',
    count: 29,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Sunday',
    hr: '6 am',
    count: 16,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Sunday',
    hr: '7 am',
    count: 16,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Sunday',
    hr: '8 am',
    count: 13,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Sunday',
    hr: '9 am',
    count: 21,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Sunday',
    hr: '10 am',
    count: 10,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Sunday',
    hr: '11 am',
    count: 14,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Sunday',
    hr: '12 pm',
    count: 21,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Sunday',
    hr: '1 pm',
    count: 32,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Sunday',
    hr: '2 pm',
    count: 26,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Sunday',
    hr: '3 pm',
    count: 12,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Sunday',
    hr: '4 pm',
    count: 19,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Sunday',
    hr: '5 pm',
    count: 26,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Sunday',
    hr: '6 pm',
    count: 23,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Sunday',
    hr: '7 pm',
    count: 33,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Sunday',
    hr: '8 pm',
    count: 58,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Sunday',
    hr: '9 pm',
    count: 36,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Sunday',
    hr: '10 pm',
    count: 52,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Sunday',
    hr: '11 pm',
    count: 41,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Sunday',
    hr: '12 am',
    count: 54,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Sunday',
    hr: '1 am',
    count: 40,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Sunday',
    hr: '2 am',
    count: 37,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Sunday',
    hr: '3 am',
    count: 42,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Sunday',
    hr: '4 am',
    count: 32,
  },
  {
    offenseCategory: 'Robbery',
    dow: 'Sunday',
    hr: '5 am',
    count: 22,
  },
]
